import {
  Facebook,
  Instagram,
  YouTube,
  Place,
  LocalPhoneRounded,
  EmailSharp,
  AccessTimeFilledRounded,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="flex flex-col shadow-slate-95000 shadow-md bg-[#0B4543] text-white md:px-5 mt-4 pt-4">
      <div className="flex md:flex-row w-full justify-evenly flex-wrap">
        <div className="flex flex-col md:w-[40%] md:pr-[10%] mt-8 md:ml-10 text-left">
          <img
            src="vpack-logo-4.svg"
            alt="Logo"
            className="mx-auto md:ml-4 md:mr-6 object-contain max-w-[100px] md:max-w-[180px]"
          />
          <div className="mt-5 leading-[18px] font-HNlight text-center md:text-left text-sm md:text-base px-4">
            Our client’s safety and reputation are our major concern. We provide
            products equipped with the finest and cutting-edge technologies.
          </div>
        </div>
        <div className="flex flex-col my-10 text-left px-3 self-center font-HNmed text-sm md:text-base">
          <div className="align-middle">
            <Place className="text-[#00E0DA] mr-2" />
            Mundoor
          </div>
          <div>
            <LocalPhoneRounded className="text-[#00E0DA] mr-2" />
            9745507771
          </div>
          <div>
            <EmailSharp className="text-[#00E0DA] mr-2" />
            vpack7771@gmail.com
          </div>
          <div>
            <AccessTimeFilledRounded className="text-[#00E0DA] mr-2" />
            Mon-Sat : 9:30 - 18:00
          </div>
        </div>
        <div className="flex flex-col my-10 text-left self-center font-medium text-lg mx-4">
          <div>
            <Link
              to={"/home"}
              onClick={() => {
                window.location.href = "#";
              }}
            >
              Home
            </Link>
          </div>
          <div>
            <Link
              to={"/aboutus"}
              onClick={() => {
                window.location.href = "#";
              }}
            >
              About Us
            </Link>
          </div>
          <div>
            <Link
              to={"/products"}
              onClick={() => {
                window.location.href = "#";
              }}
            >
              Products
            </Link>
          </div>
          <div>
            <Link
              to={"/contactus"}
              onClick={() => {
                window.location.href = "#";
              }}
            >
              Contact Us
            </Link>
          </div>
        </div>
        <div className="flex flex-col my-10 text-left px-3 self-center font-HNheavy">
          <div>Follow us on</div>
          <div>social media</div>
          <div className="text-[#00E0DA] text-center">
            <YouTube />
            <Instagram />
            <Facebook />
          </div>
        </div>
      </div>
      <div className="flex text-center mb-10 justify-center">
        Copyright 2024 © All Rights Reserved
      </div>
    </div>
  );
};

export default Footer;
